import { render, staticRenderFns } from "./ReportCourseOverview.vue?vue&type=template&id=b92d14ca&scoped=true&"
import script from "./ReportCourseOverview.vue?vue&type=script&lang=js&"
export * from "./ReportCourseOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b92d14ca",
  null
  
)

export default component.exports